import { useAllReceipts } from '../../../../../hooks/fetchers/useAllReceipts/useAllReceipts';
import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import moment from 'moment';
import Button from '../../../../designSystem/Button/Button';
import Loading from '../../../../commons/Loading/Loading';
import { ButtonColor } from '../../../../designSystem/Button/Button.types';
import { useCurrentUser } from '../../../../../hooks/useCurrentUser/useCurrentUser';
import { UserENT } from '../../../../../types/models/user/user.types';
import { downloadReceiptENT } from './DashboardReceiptsENT.query';
import { formatNumberWithLeadingZeros } from '../../../../../utils/helpers/numbers/formatNumberWithLeadingZeros';

export default () => {
  const currentUser = useCurrentUser() as UserENT;

  const { data, isLoading } = useAllReceipts();

  if (isLoading) return <Loading />;

  return (
    <DashboardLayout>
      <table style={{ flex: 0 }} className="dashboard__table dashboard-commerciaux__table">
        <colgroup>
          <col style={{ width: '65%' }} />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th>Facture</th>
            <th>Date</th>
            <th>Montant</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.length > 0 &&
            data.map(({ id, total_TTC, created_at }, index) => (
              <tr key={index} className={'dashboard-commerciaux__table-tr--clickable'}>
                <td>Facture n°{formatNumberWithLeadingZeros(id)}</td>
                <td style={{ textTransform: 'capitalize' }}>
                  {moment(created_at).format('DD/MM/YYYY')}
                </td>
                <td>{(total_TTC / 100).toFixed(2)}€</td>
                <td>
                  <Button
                    onClick={() => downloadReceiptENT(id, currentUser.id)}
                    color={ButtonColor.Secondary}>
                    Télécharger
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </DashboardLayout>
  );
};
